<template>
  <v-list-tile
    v-model="isActive"
    active-class="list-item-active"
    ref="widget"
    @click="setActiveWidget(widget.id)"
  >
    <v-list-tile-action>
      <v-icon v-if="widget.icon">{{widget.icon}}</v-icon>
    </v-list-tile-action>
    <v-list-tile-content>
      <v-list-tile-title v-text="widget.name"></v-list-tile-title>
    </v-list-tile-content>
    <v-list-tile-action>
      <v-btn
        @click.stop="deleteWidget(widget.id)"
        :class="{'white--text': isActive}"
        flat
        icon
      >
        <v-icon>delete</v-icon>
      </v-btn>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
import { SET_ACTIVE_WIDGET } from '@/store/actions/layouteditor';

export default {
  props: {
    widget: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
  created() {
    this.$events.fire('set-active-widget-component', this.widget.id);
    this.$events.fire('deactivate-widgets-manager-items');
    this.$store.dispatch(SET_ACTIVE_WIDGET, this.widget.id);
    this.isActive = true;
  },
  methods: {
    deleteWidget(id) {
      this.$store.dispatch(`widget${id}/CLEAR_CLOCK_TIMER`);
      this.$store.unregisterModule(['widgets', `widget${id}`]);
    },
    setActiveWidget(id) {
      this.$events.fire('set-active-widget-component', id);
      this.$events.fire('deactivate-widgets-manager-items');
      this.$store.dispatch(SET_ACTIVE_WIDGET, id);
      this.isActive = true;
    },
  },
};
</script>

<style>
.list-item-active {
  color: white;
  background-color: #E91E63;
  border-radius: 0.25rem;
}
</style>
